import { Component, OnInit, OnDestroy, Inject, PLATFORM_ID } from '@angular/core';
import { Router, RouterOutlet, NavigationEnd } from '@angular/router';
import { FooterComponent } from './footer/footer.component';
import { HeaderComponent } from './header/header.component';
import { UserService } from './user/user.service';
import { User } from './user/user';
import { CommonModule, isPlatformBrowser } from '@angular/common';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { AppStore } from './store/app-store';
import { filter, Subscription } from 'rxjs';
import { scrollToFragment } from './utils/scroll-to-fragment';

@Component({
    selector: 'app-root',
    standalone: true,
    imports: [RouterOutlet, TranslateModule, CommonModule, HeaderComponent, FooterComponent],
    templateUrl: './app.component.html',
    styleUrl: './app.component.scss'
})
export class AppComponent implements OnInit, OnDestroy { 
  user!: User;
  currencyEUR!: boolean; 
  isDayMode = true;
  private routerSubscription?: Subscription;

  constructor(
    private userService: UserService,
    private router: Router,
    @Inject(PLATFORM_ID) private platformId: Object,
    private appStore: AppStore,
    public translate: TranslateService
  ) {}
isAppLanguage(language: string): boolean {
  const availableLangs = this.translate.getLangs(); // např. ['en', 'cs', 'de']
  return availableLangs.includes(language);
}

  switchLang(lang: string) {
    this.translate.use(lang);
    if (isPlatformBrowser(this.platformId)) {
      document.documentElement.lang = lang;
    }
  }
      setCurrencyEUR(lang: string | undefined) {
        if ((lang === 'cs') || (lang === undefined)  ) {
            this.currencyEUR = false;
             this.userService.setCurrency(false); 
        } else {
            this.currencyEUR = true;
             this.userService.setCurrency(true); 
        }
    }

ngOnInit() {
  if (isPlatformBrowser(this.platformId)) {
    this.routerSubscription = this.router.events.pipe(
      filter((e): e is NavigationEnd => e instanceof NavigationEnd)
    ).subscribe(() => {
      const fragment = this.router.parseUrl(this.router.url).fragment;
      if (fragment) {
        scrollToFragment(fragment);
        setTimeout(() => scrollToFragment(fragment, 20, 50), 200);
      }
    });
  }

  this.userService.user$.subscribe(user => {
    if (user) {
      this.user = user;

      let lang = this.appStore?.getLang() ?? user.language ?? this.translate.getBrowserLang();

      if (this.isAppLanguage(lang)) {
        this.switchLang(lang);
      }

      this.setCurrencyEUR(lang);
    } else {
      this.currencyEUR = false;
    }
  });

  // Spustíme načtení uživatele
  this.userService.getUserInfo().catch(() => {
    this.currencyEUR = false;
  });
}

ngOnDestroy(): void {
  this.routerSubscription?.unsubscribe();
}


}

